import type { LexicalEditor } from 'lexical';
import {
  EDITOR_STATE_SCHEMA_VERSION,
  LEXICAL_VERSION,
  isClipboardPayload,
  type ClipboardSource,
  type TGPEClipboardPayload,
} from './schema';

export function buildClipboardPayload(
  editor: LexicalEditor,
  source: ClipboardSource,
): string {
  const state = editor.getEditorState().toJSON();
  const payload: TGPEClipboardPayload = {
    tgpe_version: EDITOR_STATE_SCHEMA_VERSION,
    lexical_version: LEXICAL_VERSION,
    created_at: new Date().toISOString(),
    source_client: source,
    state,
  };
  return JSON.stringify(payload);
}

export interface ParseResult {
  payload: TGPEClipboardPayload | null;
  /** Set when the JSON parsed and shape was valid but the schema version differs. */
  versionMismatch?: { got: string; expected: string };
}

export function tryParseClipboardPayload(raw: string): ParseResult {
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return { payload: null };
  }
  if (!isClipboardPayload(parsed)) return { payload: null };
  if (parsed.tgpe_version !== EDITOR_STATE_SCHEMA_VERSION) {
    return {
      payload: null,
      versionMismatch: {
        got: parsed.tgpe_version,
        expected: EDITOR_STATE_SCHEMA_VERSION,
      },
    };
  }
  return { payload: parsed };
}
